import get from 'lodash.get';

import env from '#shared/config/env.js';

import isString from './isString.js';
import isObject from './isObject.js';

/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {

	/**
	 * Update url query parameters
	 * - Combine multiple parameters (eg. "product", "quantity")
	 * - Remove empty parameters (eg. "&param=", "&param")
	 * - Combine with provided "customQuery" parameter
	 * @param {object} customQuery
	 * @param {string} customHash
	 * @returns {Promise}
	 */
	Vue.prototype.updateUrlQuery = function(customQuery = {}, customHash) {
		const error = get(this.$store, 'state.error', null);
		const order = get(this.$store, 'state.order', {});
		const page = get(this.$store, 'state.page', {});
		const query = get(this.$store, 'state.route.query', {});
		const hash = get(this.$store, 'state.route.hash', '');
		// If "blank page" (eg. payment/gateway-succes) is being loaded or error was returned do not modify the URL
		if (page.isBlankPage || isObject(error)) {
			return Promise.resolve();
		}
		// Remove all parameters which should not stay in URL
		env.toClearParameters.forEach((name) => {
			query[name] = null;
		});
		// Make sure authenticated flow related parameters are removed in guest flow
		query.shopper = order.isGuest ? null : query.shopper;
		query.sid = order.isGuest ? null : query.sid;
		query.aid = order.isGuest ? null : query.aid;

		/**
		 * In case of OMS flow, there should be no "product" and "quantity" parameters
		 * in the URL as single order could contain 1000+ products which would lead
		 * into very long URL. For other than OMS flow, update the parameters with
		 * the current state of the checkout.
		 */
		if (order.isOmsFlow) {
			query.product = null;
			query.quantity = null;
		} else {
			const {
				products,
				quantities
			} = order.products.reduce((previous, { id, quantity }) => {
				previous.products.push(id);
				previous.quantities.push(quantity);
				return previous;
			}, {
				products: [],
				quantities: []
			});
			query.product = products.join(',');
			query.quantity = quantities.join(',');
		}
		query.customID = order.customIDs.join(',');
		query.campaign = order.campaign || '';
		query.afbData = order.afbData.string || '';
		query.aswparam = order.aswparam.string || '';
		// Create updated query parameters entries and filter out parameters without any value (eg. "&param=" or "&param")
		const modifiedQueryEntries = Object.entries({
			...query,
			...customQuery
		}).filter(([, value]) => isString(value, 1));
		// Create updated url hash
		const modifiedHash = isString(customHash) ? customHash : hash;
		// Push the modified query to the router so it updates without reload
		return this.$router.push({
			query: Object.fromEntries(modifiedQueryEntries),
			hash: modifiedHash
		}).catch(() => {});
	};

};

export default {
	install
};
